import { supabase } from "../supabase";
import { request, API_V1_PREFIX, type RequestOptions } from "./client";
import type { TokenResponse } from "./types";

export async function loginAccessToken(email: string, password: string, options: RequestOptions = {}): Promise<TokenResponse> {
  const body = new URLSearchParams({
    username: email.trim().toLowerCase(),
    password,
  });

  return request<TokenResponse>(
    `${API_V1_PREFIX}/login/access-token`,
    {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
      },
      body,
    },
    options,
  );
}

export async function recoverPassword(email: string): Promise<{ message: string }> {
  const { error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${window.location.origin}/reset-password`,
  });

  if (error) {
    throw error;
  }

  return { message: "Email de recuperação enviado com sucesso" };
}

export async function resetPassword(newPassword: string): Promise<boolean> {
  const { error } = await supabase.auth.updateUser({
    password: newPassword,
  });

  if (error) {
    throw error;
  }

  return true;
}
